import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
import { getUserWiseTourBookingReport } from "../services/reports.services";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";

const UserWiseBookingReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/userwisetourbookingreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/userwisetourbookingreportform",
    PRINT_ACCESS
  );

  const UserID = params?.UserID;
  const FromDate = params?.FromDate;
  const ToDate = params?.ToDate;
  const TourID = params?.TourID;

  const loading = useAppSelector((state) => state.reports.loading);
  const UserWiseTourBookingReport = useAppSelector(
    (state) => state.reports.UserWiseTourBookingReport
  );
  useEffect(() => {
    if (UserID && FromDate && ToDate) {
      const payload = {
        UserID: UserID ? +UserID : null,
        FromDate: FromDate ? FromDate : "",
        ToDate: ToDate ? ToDate : "",
        TourID: TourID !== "0" ? TourID : null,
      };
      dispatch(getUserWiseTourBookingReport(payload));
    }
  }, []);

  let totalAdults = 0;
  let totalChildren = 0;
  UserWiseTourBookingReport &&
    UserWiseTourBookingReport.length > 0 &&
    UserWiseTourBookingReport?.forEach((booking: any) => {
      totalAdults += booking?.TotalAdults || 0;
      totalChildren += booking?.TotalChilds || 0;
    });

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "UserWiseTourBookingReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "userwisetourbookingreport.xlsx");
  };

  const printTable = () => {
    let table = document.querySelector(
      ".table-bordered"
    ) as HTMLTableElement | null;
    let printbuttons = document.querySelector(".printbuttons") as any;
    let report_container = document.querySelector(".report-container") as any;
    if (!table) {
      console.error("Table element not found.");
      return;
    }

    printbuttons.style.display = "none";
    report_container.style.padding = "20px 0";
    let tableRows = table.rows.length;
    let maxRows = table.rows.length;
    let pageCount = Math.ceil(tableRows / maxRows);
    let printContent = document.createElement("div");
    let content = "";

    for (let i = 0; i < pageCount; i++) {
      content += '<div class="print-page">';
      //   content += "<h2>Page " + (i + 1) + "</h2>";
      content += '<table class="table table-bordered reportScreens">';

      let startRow = i * maxRows;
      let endRow = Math.min((i + 1) * maxRows, tableRows);

      for (let j = startRow; j < endRow; j++) {
        content += table.rows[j].outerHTML;
      }

      content += "</table>";
      content += "</div>";
    }

    printContent.innerHTML = content;
    table.style.display = "none";
    document.body.appendChild(printContent);

    const style = document.createElement("style");
    style.textContent = `@page { margin: 1cm; }`;
    document.head.appendChild(style);

    window.print();
    printContent.remove();
    table.style.display = "table";
    printbuttons.style.display = "block";
    report_container.style.padding = "20px 10px";
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          User Wise Tour Booking Report{" "}
          <span style={{ fontSize: 15 }}>
            (
            {FromDate
              ? moment(FromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
              : ""}
            {" to "}
            {ToDate ? moment(ToDate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={printTable}
            >
              Print
            </Button>
          )}
          {isExcelExportAccess && (
            <Button
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={handleExportExcel}
            >
              Excel Export
            </Button>
          )}
        </div>
      </div>
      <div className="table-responsive" style={{ margin: "0 10px" }}>
        <table className="table table-bordered reportScreens">
          <thead>
            <tr>
              <th style={{ background: "black", color: "white" }}>No</th>
              <th style={{ background: "black", color: "white" }}>
                Booking Date
              </th>
              <th style={{ background: "black", color: "white" }}>
                Tour Booking No
              </th>
              <th style={{ background: "black", color: "white" }}>Tour Name</th>
              <th style={{ background: "black", color: "white" }}>
                Customer Name
              </th>
              <th style={{ background: "black", color: "white" }}>
                Tour Start Date
              </th>
              <th style={{ background: "black", color: "white" }}>
                No Of Nights
              </th>
              <th style={{ background: "black", color: "white" }}>
                Total Adults
              </th>
              <th style={{ background: "black", color: "white" }}>
                Total Children
              </th>
              <th style={{ background: "black", color: "white" }}>Book By</th>
              <th style={{ background: "black", color: "white" }}>Branch</th>
            </tr>
          </thead>
          <tbody>
            {UserWiseTourBookingReport &&
              UserWiseTourBookingReport.length > 0 &&
              UserWiseTourBookingReport?.map((user: any, index: number) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>
                    {user?.BookingDate
                      ? moment(user?.BookingDate, "DD/MM/YYYY").format(
                          "DD MMM YYYY"
                        )
                      : ""}
                  </td>
                  <td>{user?.TourBookingNo}</td>
                  <td>{user?.TourName}</td>
                  <td>{user?.CustomerName}</td>
                  <td>
                    {user?.TourStartDate
                      ? moment(user?.TourStartDate, "DD/MM/YYYY").format(
                          "DD MMM YYYY"
                        )
                      : ""}
                  </td>
                  <td>{user?.NoOfNights || 0}</td>
                  <td>{user?.TotalAdults || 0}</td>
                  <td>{user?.TotalChilds || 0}</td>
                  <td>{user?.BookBy}</td>
                  <td>{user?.Branch}</td>
                </tr>
              ))}
            <tr className="fw-bold">
              <td
                colSpan={7}
                className="text-end pe-5"
                style={{ background: "lightgray", color: "black" }}
              >
                Total
              </td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalAdults}
              </td>
              <td style={{ background: "lightgray", color: "black" }}>
                {totalChildren}
              </td>
              <td style={{ background: "lightgray", color: "black" }}></td>
              <td style={{ background: "lightgray", color: "black" }}></td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default UserWiseBookingReportView;
